import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'
import OneSignal from 'onesignal-cordova-plugin'
import { SafeArea } from '@capacitor-community/safe-area';

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const getOneSignal = () => (window as any).OneSignal

export async function initMobile() {
	try {
		console.log('📱 Initializing mobile environment')

		// StatusBar config
    // remove on android
		// await StatusBar.setOverlaysWebView({ overlay: false })
		await StatusBar.setStyle({ style: Style.Default })

    // safe area config
    console.log('Configuring safe area')
    await SafeArea.enable({
      config: {
        customColorsForSystemBars: true,
        statusBarColor: '#00000000',
        statusBarContent: 'light',
        navigationBarColor: '#00000000',
        navigationBarContent: 'light'
      }
    });
    const top = getComputedStyle(document.documentElement)
      .getPropertyValue('--safe-area-inset-top');
    console.log('safe-area top =', top);


		// Hide native splash
		await SplashScreen.hide()

		// OneSignal setup
		console.log('📡 Initializing OneSignal')
		OneSignal.Debug.setLogLevel(6)
		OneSignal.initialize(import.meta.env.VITE_ONESIGNAL_APP_ID)

		const accepted = await OneSignal.Notifications.requestPermission(false)
		console.log('🔔 User accepted notifications:', accepted)

		OneSignal.Notifications.addEventListener('click', (event) => {
			console.log('🔔 Notification clicked:', event)
		})
	} catch (err) {
		console.error('❌ initMobile error:', err)
	}
}

const initWebOneSignal = async () => {
		if (typeof window === 'undefined') return

		// Prevent double init
		if ((window as any).OneSignal?.initialized) return
		;(window as any).OneSignalDeferred = (window as any).OneSignalDeferred || []

		// Load OneSignal SDK v16
		await new Promise<void>((resolve, reject) => {
			const script = document.createElement('script')
			script.src = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js'
			script.defer = true
			script.onload = () => resolve()
			script.onerror = () => reject(new Error('OneSignal SDK failed to load'))
			document.head.appendChild(script)
		})

		// Use the recommended OneSignalDeferred method
		;(window as any).OneSignalDeferred.push(async (OneSignal: any) => {
			await OneSignal.init({
				appId: import.meta.env.VITE_ONESIGNAL_APP_ID,
				allowLocalhostAsSecureOrigin: true,
        notificationClickHandlerMatch: 'origin',
        notificationClickHandlerAction: 'focus',
				autoResubscribe: true,
				notifyButton: {
					enable: false, // Disable the floating bell
				},
				welcomeNotification: {
					disable: true, // We’ll handle messaging manually
				},
			})

			await OneSignal.User.PushSubscription.optIn()
		})
	}

export async function initWeb() {
	console.log('💻 Web init placeholder (extend as needed)')
	initWebOneSignal()
}

function setViewportHeight() {
	const vh = window.visualViewport?.height || window.innerHeight;
	document.documentElement.style.setProperty('--vh', `${vh * 0.01}px`);
}

function initViewportFix() {
	// Set initial
	setViewportHeight();

	// Listen for changes
	window.addEventListener('resize', setViewportHeight);
	window.addEventListener('orientationchange', setViewportHeight);
}

export async function initApp() {
	try {
    initViewportFix(); // 🧠 always run it

		if (Capacitor.isNativePlatform()) {
			await initMobile()
		} else {
			await initWeb()
		}
	} catch (err) {
		console.error('❌ initApp error:', err)
	}
}
